/************************
 * EVENTOS PARA PLAYERS *
 ************************/

export function analisisDeJugadoresElegirEquipo(team_id) {
  dataLayer.push({
    event: 'analisis_de_jugador_elegir_equipo',
    team_id,
  });
}

export function analisisDeJugador(team_id, player_id) {
  dataLayer.push({
    event: 'analisis_de_jugador',
    team_id,
    player_id,
  });
}

export function analisisDeJugadorPosesion(season_id, team_id, player_id) {
  dataLayer.push({
    event: 'analisis_de_jugador_posesion',
    season_id,
    team_id,
    player_id,
  });
}

export function analisisDeJugadorOfensivo(season_id, team_id, player_id) {
  dataLayer.push({
    event: 'analisis_de_jugador_ofensivo',
    season_id,
    team_id,
    player_id,
  });
}

export function analisisDeJugadorDefensivo(season_id, team_id, player_id) {
  dataLayer.push({
    event: 'analisis_de_jugador_defensivo',
    season_id,
    team_id,
    player_id,
  });
}

export function analisisDeJugadorFiltros(season_id, team_id, player_id, view) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtros',
    season_id,
    team_id,
    player_id,
    view,
  });
}

export function analisisDeJugadorFiltroTemporada(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtro_temporada',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorFiltroEstadistica(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtro_estadistica',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorFiltroJugadoComo(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtro_jugado_como',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorFiltroPorResultado(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtro_por_resultado',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorFiltroPorTiempo(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_filtro_por_tiempo',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorSeccionVista(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_seccion_vista',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorCategoriasDeTabla(season_id, team_id, player_id, category, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_categorias_de_tabla',
    season_id,
    team_id,
    player_id,
    category,
    view,
    value,
  });
}

export function analisisDeJugadorTablaGrafica(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_tabla_o_grafica',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorCategoriaDePizarrra(season_id, team_id, player_id, view, category, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_categoria_de_pizarra',
    season_id,
    team_id,
    player_id,
    view,
    category,
    value,
  });
}

export function analisisDeJugadorSeleccionTodoPizarra(season_id, team_id, player_id, view, category, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_selecciontodopizarra',
    season_id,
    team_id,
    player_id,
    view,
    category,
    value,
  });
}

export function analisisDeJugadorVistaPizarra2D3D(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_vista_pizarra_2d_3d',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorCategoriaDePorteria(season_id, team_id, player_id, view, category, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_categorias_porteria',
    season_id,
    team_id,
    player_id,
    view,
    category,
    value,
  });
}

export function analisisDeJugadorDetallesCategoria(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_detalles_categoria',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}

export function analisisDeJugadorDetalleSubcategoria(season_id, team_id, player_id, view, value) {
  dataLayer.push({
    event: 'analisis_de_jugador_detalle_subcategoria',
    season_id,
    team_id,
    player_id,
    view,
    value,
  });
}
